import React from "react";
import { useLocation } from "react-router-dom";
import localData from "../../localData";
import { Navbar } from "../";
import { Button } from "../";
import pdf from "../../assets/karenwerner.pdf";

export default function Header() {
    const location = useLocation();

    const { cover, signature } = localData.user;
    const { linkedin, github, twitter, facebook } = localData.svgs;

    const navs = [
        {
            title: "home page title",
            content: "home page header",
            subtitle: "home page subtitle",
            pathname: "/",
        },
        {
            title: "about page title",
            content: "about page header",
            subtitle: "about page subtitle",
            pathname: "/about",
        },
    ];



    return (
        <header className="hero" id="home" data-lazy-block>
            <Navbar />
            <div className="container">
                <div className="hero-center">
                    <div className="wrapper">
                        <div className="hero-avatar">
                            <img src={cover} alt="" data-lazy="fade-right" />
                        </div>
                    </div>
                    <div className="info">
                        <h6 className="info-sup">web developer</h6>
                        <h1 className="info-title">Karen Werner</h1>
                        <p className="info-description">
                            As a developer, my superpower happens behind the scenes to make a website look great, work
                            fast and perform well with a seamless user experience.
                        </p>
                        <div className="wrapper">
                            <a href={pdf} download="resume" target="_blank" rel="noreferrer">
                                <Button className="btn btn-outline-warning">download CV</Button>
                            </a>
                         <a href="/#contact" >
                                <Button   className="btn btn-warning">
                                    contact
                                </Button>
                         </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <ul className="socials">
                    <a href="https://www.facebook.com/profile.php?id=100077074302853" target='_blank' className="socials-link">
                        {facebook}
                    </a>
                    <a href="https://twitter.com/Karen42775967" target='_blank' className="socials-link">
                        {twitter}
                    </a>
                    <a href="https://www.linkedin.com/in/karenwerner09/" target='_blank' className="socials-link">
                        {linkedin}
                    </a>
                    <a href="https://github.com/Karen09w" target='_blank' className="socials-link">
                        {github}
                    </a>
                </ul>
            </div>
        </header>
    );
}
